import palette from '../palette';

export default {
  contained: {
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
    backgroundColor: '#eceff1',
    height: '42px',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '12px',
    "&:hover": {
      boxShadow: "none"
    },
    // MUI v4 applied the color variant after the generic `contained` rule.
    // Keep that visual precedence explicitly under MUI v5.
    "&.MuiButton-containedPrimary": {
      color: '#fff',
      backgroundColor: '#2B3990',
      "&:hover": {
        backgroundColor: '#0D1C6A',
      },
    },
    "&.MuiButton-containedSecondary": {
      color: '#ffeacb',
      backgroundColor: '#fbaa33',
      "&:hover": {
        backgroundColor: '#513102',
      },
    },
    "&.Mui-disabled": {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    }
  },
  root: {
    height: '42px',
    padding: '8px 22px',
    fontSize: '12px',
    // Keep the neutral v4 default at the root specificity. Page-level JSS
    // classes must remain able to override it (for example destructive
    // actions), while MUI color variants still apply their own slot rules.
    color: palette.text.primary,
    "&.MuiButton-outlinedPrimary, &.MuiButton-outlined": {
      borderRadius: '8px',
      padding: '5px 15px',
    },
  },
};
